<template>
  <div class="myinfo">
    <div class="erweitu">
      <!-- <img src="../../../assets/images/weixin-xgdjxjxw.jpg" /> -->
      <div class="codeTitle">扫码登录</div>
      <div class="remarkTitle">请使用微信扫一扫登录</div>
      <div class="code" @click="getQrCode">
        <canvas ref="qrCanvas"></canvas>
      </div>
      <div class="tip">
        扫码视为同意
        <span class="clickText" @mousedown.prevent @click.stop="handleUserAgree">用户协议</span>
        和
        <span class="clickText" @mousedown.prevent @click.stop="handlePrivacyPolicy">隐私政策</span>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import common from '@/common/js/common.js';
export default {
  name: 'ViewState',
  props: {
    arrs: Array,
  },
  data: function() {
    return {
      randomCode: null,
      isScanning: false, // 新增标志
      cancelTokenSource: null,
      websock: null,
      timer: null,
    };
  },
  methods: {
    handleUserAgree(event) {
      event.preventDefault();
      // window.open('https://app.jxjypt.cn/yhxy.html', '_blank');
      window.open('https://videos.jxjypt.cn/cj21/yhxy.html', '_blank');
    },
    handlePrivacyPolicy(event) {
      event.preventDefault();
      // window.open('https://app.jxjypt.cn/yszc.html', '_blank');
      window.open('https://videos.jxjypt.cn/cj21/yszc.html', '_blank');
    },
    onMessage(e) {
      const websocketMsg = JSON.parse(e.data);
      if (websocketMsg.success) {
        common.loginSuccess(websocketMsg.result.token, websocketMsg.result.userInfo);
        const message = {
          cmd: 'saveLog',
          msgTxt: websocketMsg.result.userInfo,
        };
        this.sendWebSocketMessage(JSON.stringify(message));
      } else {
        if (websocketMsg.message == '请刷新后重试') {
          this.$message.warning('二维码已失效，请点击二维码刷新后重试');
          this.onClose();
        } else if (websocketMsg.message == '学生信息绑定异常') {
          this.$message.warning('学生信息绑定异常');
          this.onClose();
        }
      }
    },
    onClose() {
      /* clearInterval(this.timer);
      this.timer = null;*/
      this.closeWebSocket();
      window.removeEventListener('beforeunload', this.closeWebSocket);
    },
    openWebSocket() {
      var url = `${process.env.stuWebsocketURL}`;
      this.closeWebSocket();
      this.websock = new WebSocket(url + 'webSocketQrCode/' + this.randomCode);
      this.websock.onmessage = this.onMessage;
      /*clearInterval(this.timer)
      this.timer = setInterval(() => {
        var message = {
          type: '1',
          qrCode: this.randomCode
        }
        this.sendWebSocketMessage(JSON.stringify(message));
      }, 10000);*/
    },
    closeWebSocket() {
      if (this.websock && this.websock.readyState === WebSocket.OPEN) {
        this.websock.close();
      }
    },
    sendWebSocketMessage(message) {
      // 检查WebSocket连接状态（1表示连接已建立）
      if (this.websock && this.websock.readyState === WebSocket.OPEN) {
        try {
          // 发送消息
          this.websock.send(message);
        } catch (error) {
          console.error('消息发送失败:', error);
        }
      } else {
        console.warn('WebSocket未连接，无法发送消息');
      }
    },
    getQrCode() {
      this.axios.get('/sys/login/getQrCode?qrCode=' + this.randomCode).then(res => {
        // 先获取 redirect_uri 的参数部分
        const url = res.result;
        const urlObj = new URL(url);
        const stateValue = urlObj.searchParams.get('state');
        this.randomCode = stateValue; // 保存 randomCode
        this.openWebSocket();
        // 获取 canvas 元素的引用
        const canvas = this.$refs.qrCanvas;
        // 设定 canvas 的宽高（可根据需求调整）
        canvas.width = 200;
        canvas.height = 200;
        // 调用 QRCode 函数生成二维码，并渲染到 canvas 上
        QRCode.toCanvas(canvas, res.result, { width: 225 }, error => {
          if (error) console.error(error);
        });
        /*this.scanCodeLogin();*/
      });
    },
    scanCodeLogin() {
      if (this.isScanning) return; // 已有请求在进行
      this.isScanning = true;
      // 创建取消令牌
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('组件重复创建，取消上一次请求');
      }
      this.cancelTokenSource = this.axios.CancelToken.source();
      this.axios
        .get('/sys/login/scanCodeLogin?randomCode=' + this.randomCode, {
          cancelToken: this.cancelTokenSource.token,
        })
        .then(res => {
          if (res.success) {
            common.loginSuccess(res.result.token, res.result.userInfo);
          } else {
            if (res.message == '请刷新后重试') {
              this.$message.warning('二维码已失效，请点击二维码刷新后重试');
            } else {
              // 继续轮询
              this.isScanning = false;
              this.scanCodeLogin();
            }
          }
        })
        .catch(error => {
          if (this.axios.isCancel && this.axios.isCancel(error)) {
            console.log('请求已取消：', error.message);
          } else {
            console.error('扫码登录失败:', error);
          }
          this.isScanning = false; // 重置标志
        });
    },
  },
  mounted() {
    this.getQrCode();
  },
  beforeDestroy() {
    this.onClose();
    this.isScanning = false;
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('组件销毁，取消请求');
    }
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.myinfo{
  height: 333px;
  .erweitu{
    width:230px;
    margin:0 auto;
    margin-top:0px;
    img{
      width:180px;
      height:180px;
    }
  }
  .codeTitle {
    text-align: center;
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .remarkTitle {
    text-align: center;
    font-size: 16px;
    margin-bottom: 18px;
  }
  .code {
    width: 227px;
    height: 227px;
    border: 1px solid #ddd;
    canvas {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
    color: #999;

    .clickText {
      color: #1890ff;
      margin-left: 2px;
      margin-right: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LoginIndex/components/ViewTrack.vue